import React, { Component } from 'react';

export default class Wellcome extends Component {
	
	state ={hover:false, clicked: false}
	
	render() {
		const {language} = this.props;

		const shadows = {
			normal: "0 2px 2px rgba(0, 0, 0, 0.2)", 
			hover: "0 2px 8px rgba(0, 0, 0, 0.4)",
			clicked: "0 8px 16px rgba(0, 0, 0, 0.4)"
		} ;

		global.showFooter = false;

		return <div style={{
			backgroundColor: "#4285f4",
			width: 360,
			height: 640,
		}}>
				<img src={require('./img/Android_O_01.png')} style={{
				position:"absolute",  
				width:"100%",
				height: "auto",
			}} />
			<div style={{
				position:"absolute",  
				left: 24,
				right: 24,
				height: 40,
				top: 132,
				textAlign: "center",
				color:  "white",
				fontSize: 36,
				// backgroundColor: "rgba(200,100,0,0.3)",
			}}>Welcome</div>
			<LanguageSelection currentLanguage={language} languagesList={["EN","DE","CS","NL","FR","IT","PL","BG","DA","FI","EL","HU","LV","LT","NB","PT","RO","SV","TR","UK"]}/>
			<div style={{
				position:"absolute",
				zIndex:12,
				right: 127,
				top: 350,			
				padding: "12px 16px 12px 16px",
				borderRadius: 2,
				backgroundColor: this.state.clicked ? "#fff9b1" : this.state.hover ? "#fff264" : "#ffea00",
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
                cursor:"pointer",
				boxShadow: this.state.clicked ? shadows.clicked : this.state.hover ?  shadows.hover :  shadows.normal,
				transition:"all 0.2s ease-out",
			}} 
			onMouseEnter={() => {
				this.setState({hover:true})
			}} onMouseLeave={() => {
				this.setState({hover:false, clicked:false})
			}} onMouseDown={()=>{
				this.setState({clicked:true, hover:false})
			}} onMouseUp={()=>{
				this.setState({clicked:false, hover:false})
			}}
			onTouchCancel={() => {
				this.setState({clicked:false})
			}} onTouchStart={()=>{
				this.setState({clicked:true})
			}} onTouchEnd={()=>{			
				this.setState({clicked:false})
			}}
			onClick={global.nextStage}>
				<span style={{
					color:"black",
					fontWeight:500,
					fontSize:16,
					letterSpacing: 1.2,
					textTransform: "uppercase",
				}}>let's go</span>
			</div>
		</div>
	}

}

export class LanguageSelection extends Component {
	
	state={dropdownIsOpen: false, sortedLanguageList: []}
	
	componentDidMount(){
		let sorted = this.props.languagesList;

		sorted.sort();

		this.setState({sortedLanguageList: sorted});
	}

	languageDictionary(lan){
		
		const lanDict = {
			"EN": "English",
			"DE": "German",
			"CS": "Czech",
			"NL": "Dutch",
			"FR": "French",
			"IT": "Italian",
			"PL": "Polish",
			"BG": "Bulgarian",
			"DA": "Danish",
			"FI": "Finnish",
			"EL": "Greek",
			"HU": "Hungarian",
			"LV": "Latvian",
			"LT": "Lithuanian",
			"NB": "Norwegian",
			"PT": "Portuguese",
			"RO": "Romanian",
			"SV": "Swedish",
			"TR": "Turkish",
			"UK": "Ukrainian",
		}
		
		return lanDict[lan];
	}

	openDropDown = () => {
		return
		if(!this.state.dropdownIsOpen){
			// console.log("open dropdown");
			this.setState({dropdownIsOpen: true});
		}
	}

	closeDropDown = () => {
		if(this.state.dropdownIsOpen){
			// console.log("close dropdown");
			this.setState({dropdownIsOpen: false});
		}
	}

	
	render(){
		const{currentLanguage} = this.props;
		const w = 150;
		const pad = 16;
		const dropdownHeight = 170;

		return <div onClick={this.closeDropDown} style={{
			position: "absolute",
			width: "100%",
			height: "100%",
			// backgroundColor: "rgba(0,255,255,0.5)",
		}}>
			<div onClick={this.openDropDown}
			style={{
				position:"absolute",
				zIndex:12,
				width: w,
				height: 32,
				top: 260,
				left: (360 - w)/2,
				// backgroundColor: "rgba(200,0,100,0.3)",
				textTransform: "uppercase",
				color: "white",
				fontWeight: 500,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				cursor: "pointer",
				}}> 
					<div style={{width:8, height:"100%"}}/> 
					{this.state.dropdownIsOpen ? `SELECT` : this.languageDictionary(currentLanguage)}
					<div style={{width:4, height:"100%"}}/> 
					<img src={require('./img/baseline-arrow_drop_down-24px.svg')}/>
				</div>
			{this.state.dropdownIsOpen && <div 
				style={{
					position:"absolute",
					zIndex: 20,
					width: w + 2*pad,
					// paddingLeft: pad,
					// paddingRight: pad,
					paddingTop: pad/2,
					paddingBottom: pad/2,
					height: dropdownHeight,
					top: 292,
					left: (360 - w-pad*2)/2,
					borderRadius: 4,
					boxShadow: "0 2px 8px rgba(0, 0, 0, 0.4)",
					backgroundColor: "rgba(255,255,255,1)",		
					overflowY: "scroll",			
				}}>
				{this.state.sortedLanguageList.map((l)=>{
					
					return <LisItem language={l} itemText={this.languageDictionary(l)} pad={pad}/>
					
					// return <li style={{
					// 	height: 32,
					// 	paddingTop: 8,
					// 	display: "flex",
					// 	alignItems: "center",
					// 	cursor: "pointer",
					// }} 
					// onClick={this.onLanguageSelect(l)
					
					// }> {this.languageDictionary(l)} </li>
				})}
			</div>}
		</div>
	}
}

export class LisItem extends Component {
	state={hover: false}

	onLanguageSelect = (lan) => {
		return function(e) {global.setLanguage(lan)}
	}

	render(){
		const {language, itemText, pad} = this.props;

		return <li 
		style={{
			height: 40,
			paddingLeft: pad,
			paddingRight: pad,
			display: "flex",
			alignItems: "center",
			cursor: "pointer",
			backgroundColor: this.state.hover? "#efefef" : "",
		}} 
		onClick={this.onLanguageSelect(language)}
		onMouseEnter={() => {this.setState({hover:true}) }} 
		onMouseLeave={() => {this.setState({hover:false}) }} 
		onTouchStart={()=>{this.setState({hover:true}) }} 
		onTouchCancel={() => {this.setState({hover:false}) }} 
		onTouchEnd={()=>{this.setState({hover:false}) }}> 
			{itemText} 
		</li>
	}
}



// WEBPACK FOOTER //
// ./src/Comp/Wellcome.js